import Button from 'components/Button';
import styled from 'styled-components';
import { GradientBackground } from 'theme/commonStyles';

export const MissionCenterContainer = styled.div`
    width: 100%;
    border-radius: 12px;
`;

export const StyledMissionCard = styled.div<{ disabled?: boolean; status?: string }>`
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000 32.22%),
        linear-gradient(
            90deg,
            var(--Background-Brand-2-70, rgba(247, 147, 26, 0.7)) 0%,
            var(--Background-Background-Brand-1-30, rgba(106, 13, 173, 0.3)) 67.5%,
            var(--Background-Brand-1, #6a0dad) 100%
        ),
        var(--Background-Primary, #000);
    border-radius: 12px;
    min-height: 280px;
    padding: 30px;
    position: relative;
    opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
    pointer-events: ${({ disabled }) => (disabled ? 'none' : 'unset')};
    user-select: ${({ disabled }) => (disabled ? 'none' : 'unset')};
    ${({ theme }) => theme.mediaWidth.upToSmall`
        padding: 20px;
    `}

    ${({ status, theme }) =>
        status
            ? `
                &::before {
                    content: "${status.replace(/([a-z])([A-Z])/g, '$1 $2')}";
                    padding: 4px 10px;
                    font-size: 12px;
                    border-radius: 0 12px;
                    position: absolute;
                    top: 0;
                    right: 0;
                    background: ${status === 'NotStart' ? theme.c.gray : theme.c.success}};
                    color: #fff;
                    z-index: 1;
                }
            `
            : undefined}
`;

export const StyledMintNftCard = styled.div<{ disabled?: boolean; status?: string }>`
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000 32.22%),
        linear-gradient(
            90deg,
            var(--Background-Brand-2-70, rgba(247, 147, 26, 0.7)) 0%,
            var(--Background-Background-Brand-1-30, rgba(106, 13, 173, 0.3)) 67.5%,
            var(--Background-Brand-1, #6a0dad) 100%
        ),
        var(--Background-Primary, #000);
    border-radius: 12px;
    padding: 30px;
    position: relative;
    opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
    pointer-events: ${({ disabled }) => (disabled ? 'none' : 'unset')};
    user-select: ${({ disabled }) => (disabled ? 'none' : 'unset')};
    ${({ theme }) => theme.mediaWidth.upToSmall`
        padding: 20px;
    `}

    ${({ status, theme }) =>
        status
            ? `
                &::before {
                    content: "${status.replace(/([a-z])([A-Z])/g, '$1 $2')}";
                    padding: 4px 10px;
                    font-size: 12px;
                    border-radius: 0 12px;
                    position: absolute;
                    top: 0;
                    right: 0;
                    background: ${status === 'NotStart' ? theme.c.gray : theme.c.success}};
                    color: #fff;
                    z-index: 1;
                }
            `
            : undefined}
`;

export const StyledButton = styled(Button)`
    width: 100%;
    padding: 8px 10px !important;
    font-size: 14px;
`;

export const GradientBox = styled.div`
    ${GradientBackground}
    border-radius: 18px;
    padding: 8px 20px;
    font-size: 14px;
`;

export const StyledPeriod = styled.div<{ active?: boolean }>`
    font-size: 14px;
    opacity: ${({ active }) => (active ? 1 : 0.5)};
    cursor: pointer;
`;
